import { render, staticRenderFns } from "./AddLs.vue?vue&type=template&id=05c5d9ce&scoped=true&"
import script from "./AddLs.vue?vue&type=script&lang=js&"
export * from "./AddLs.vue?vue&type=script&lang=js&"
import style0 from "./AddLs.vue?vue&type=style&index=0&id=05c5d9ce&prod&scoped=true&lang=css&"
import style1 from "./AddLs.vue?vue&type=style&index=1&id=05c5d9ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c5d9ce",
  null
  
)

export default component.exports